import React from 'react';
import WarningOutlined from '@ant-design/icons/WarningOutlined';
import Tag from 'antd/lib/tag';
import Tooltip from 'antd/lib/tooltip';
import Typography from 'antd/lib/typography';
import { WARNING_COLOR } from '../../../theme';

interface IDisplayedFilterFieldAndValueProps {
    fieldName: string;
    fieldValue: string;
    isFieldOutdated: boolean;
    onClose: () => void;
}

export const DisplayedFilterFieldAndValue: React.FC<IDisplayedFilterFieldAndValueProps> = ({ fieldName, fieldValue, isFieldOutdated, onClose }) => {
    return (
        <Tag closable color={isFieldOutdated ? 'gold' : 'default'} style={{ margin: 0, display: 'flex', alignItems: 'center' }} onClose={onClose}>
            {isFieldOutdated && (
                <Tooltip title="This field’s content was updated because some options are no longer available.">
                    <WarningOutlined color={WARNING_COLOR} size={12} style={{ color: WARNING_COLOR }} />
                </Tooltip>
            )}

            <Typography.Text ellipsis={{ tooltip: { title: `${fieldName}: ${fieldValue}`, placement: 'right' } }} style={{ maxWidth: 450 }}>
                {fieldName}: {fieldValue}
            </Typography.Text>
        </Tag>
    );
};
